import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/app.css';
import { isAuthResponse } from './graph/authResponse';

/** `?demo=1` turns made-up data on for this tab, `?demo=0` turns it off. */
function demoMode(): boolean {
  const q = new URLSearchParams(window.location.search).get('demo');
  try {
    if (q === '1') sessionStorage.setItem('ayb.demo', '1');
    if (q === '0') sessionStorage.removeItem('ayb.demo');
    return sessionStorage.getItem('ayb.demo') === '1';
  } catch {
    return q === '1';
  }
}

async function boot() {
  const [{ App }, { AppStore }, { AppAccount }, { MicrosoftAccount }, { openStore }] = await Promise.all([
    import('./ui/App'), import('./store/store'), import('./sync/account'), import('./graph/msal'), import('./sync/persist'),
  ]);
  const demo = demoMode();
  const kv = await openStore();
  const store = new AppStore(new AppAccount(), demo ? null : new MicrosoftAccount(), kv);
  if (demo) store.loadDemo(); else void store.start();
  createRoot(document.getElementById('root')!).render(<StrictMode><App store={store} /></StrictMode>);
  if (import.meta.env.PROD && 'serviceWorker' in navigator && !demo) {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  }
}

/** Connecting an app (Claude's connector) to the account: a page of its own, without the planner. */
async function consent() {
  const [{ ConsentPage }, { AppAccount }] = await Promise.all([import('./ui/ConsentPage'), import('./sync/account')]);
  createRoot(document.getElementById('root')!).render(<StrictMode><ConsentPage account={new AppAccount()} /></StrictMode>);
}

if (window.location.pathname.replace(/\/+$/, '') === '/oauth/consent') {
  void consent();
} else if (isAuthResponse()) {
  // Microsoft sent the sign-in answer back to this page: hand it to the window that asked.
  import('@azure/msal-browser/redirect-bridge')
    .then((m) => m.broadcastResponseToMainFrame())
    .catch(() => { window.location.replace('/'); });
} else {
  void boot();
}
